"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
var common_translations_1 = require("../../common-translations");
var keys = {
    heading: 'pageNotFound.heading',
    details: 'pageNotFound.details',
};
var defaultTranslations = (0, deepmerge_1.default)(common_translations_1.translations, {
    en: {
        pageNotFound: {
            heading: 'Page not found',
            details: "Sorry, we couldn't find what you were looking for.",
        },
    },
});
var defaultOptions = {
    keys: keys,
    defaultTranslations: defaultTranslations,
};
exports.defaultOptions = defaultOptions;
